/* UglyXmas 01-10-2026: dubbelmaat. Toont unisex dubbelmaten (S/M = herenmaat S, damesmaat M) als gewone
   heren- of damesmaat, met een schakelaar Heren | Dames. De variant (S/M) verandert niet, alleen de weergave.
   Onthoudt de laatst gekozen kant in localStorage (ux_maatsysteem). Werkt op de productpagina
   ([data-ux-dm-pdp]) en op productkaarten ([data-ux-dm-kaart]). Zie snippets/ux-dubbelmaat.liquid. */
(function () {
  if (window.__uxDubbelmaat) return;
  window.__uxDubbelmaat = true;

  var KEY = 'ux_maatsysteem';
  var DE = (document.documentElement.lang || '').toLowerCase().indexOf('de') === 0;
  var T = DE
    ? { h: 'Herren', d: 'Damen', uitleg: 'Unisex-Pullover: Herrengröße {h} ist Damengröße {d}, derselbe Pullover.' }
    : { h: 'Heren', d: 'Dames', uitleg: 'Unisex trui: herenmaat {h} is damesmaat {d}, dezelfde trui.' };

  function lees() { try { var v = localStorage.getItem(KEY); return (v === 'h' || v === 'd') ? v : null; } catch (e) { return null; } }
  function bewaar(v) { try { localStorage.setItem(KEY, v); } catch (e) {} }
  function delen(waarde) { var p = String(waarde || '').split('/'); return p.length === 2 ? { h: p[0].trim(), d: p[1].trim() } : null; }
  function naamVoorEigenschap(sys, p) { return (sys === 'd' ? T.d : T.h) + ' ' + (sys === 'd' ? p.d : p.h); }

  function zetSchakelaar(root, sys) {
    root.querySelectorAll('button[data-ux-dm-sys]').forEach(function (b) {
      var aan = b.getAttribute('data-ux-dm-sys') === sys;
      b.classList.toggle('is-actief', aan);
      b.setAttribute('aria-pressed', aan ? 'true' : 'false');
    });
  }

  /* ---------- Productkaarten ---------- */
  function kaartSys(form) {
    return form.getAttribute('data-ux-dm-kant') || 'h';
  }
  function tekenKaart(form, sys) {
    form.setAttribute('data-ux-dm-kant', sys);
    zetSchakelaar(form, sys);
    form.querySelectorAll('[data-ux-dm-h]').forEach(function (s) {
      s.textContent = s.getAttribute(sys === 'd' ? 'data-ux-dm-d' : 'data-ux-dm-h');
    });
    var prop = form.querySelector('[data-ux-dm-prop]');
    var gekozen = form.querySelector('input[name="id"]:checked');
    if (prop) {
      var label = gekozen ? gekozen.parentNode.querySelector('[data-ux-dm-h]') : null;
      prop.value = label ? naamVoorEigenschap(sys, { h: label.getAttribute('data-ux-dm-h'), d: label.getAttribute('data-ux-dm-d') }) : '';
    }
  }
  function initKaart(form) {
    if (form.__uxDm) return;
    form.__uxDm = true;
    var ctx = form.getAttribute('data-ux-dm-ctx');
    var sys = (ctx === 'h' || ctx === 'd') ? ctx : (lees() || 'h');
    if (ctx === 'h' || ctx === 'd') bewaar(ctx);
    tekenKaart(form, sys);
    form.addEventListener('click', function (e) {
      var b = e.target.closest('button[data-ux-dm-sys]');
      if (!b || !form.contains(b)) return;
      e.preventDefault();
      var nieuw = b.getAttribute('data-ux-dm-sys');
      bewaar(nieuw);
      document.querySelectorAll('[data-ux-dm-kaart]').forEach(function (f) { tekenKaart(f, nieuw); });
    });
    form.addEventListener('change', function () { tekenKaart(form, kaartSys(form)); });
  }
  function initKaarten(root) {
    (root || document).querySelectorAll('[data-ux-dm-kaart]').forEach(initKaart);
  }

  /* ---------- Productpagina ---------- */
  function initPdp(wrap) {
    var picker = wrap.closest('product-variants') || document.querySelector('product-variants');
    if (!picker) return;
    var formId = wrap.getAttribute('data-ux-dm-form');
    var uitleg = wrap.querySelector('[data-ux-dm-uitleg]');
    var fout = wrap.querySelector('[data-ux-dm-fout]');
    var prop = wrap.querySelector('[data-ux-dm-prop]');
    var schakelaar = picker.querySelector('[data-ux-dm-schakelaar]');
    var sys = lees() || wrap.getAttribute('data-ux-dm-default') || 'h';

    /* Geen maat vooraf aangevinkt (tenzij de link al een maat meegeeft, bv. vanuit Google Shopping).
       De theme-variant blijft intern staan, zodat prijs en voorraad gewoon zichtbaar blijven. */
    if (!wrap.hasAttribute('data-ux-dm-gekozen')) {
      picker.querySelectorAll('.product-variant__input').forEach(function (r) { r.checked = false; });
    }

    function gekozenRadio() { return picker.querySelector('.product-variant__input:checked'); }
    function voorbeeld() {
      var r = gekozenRadio() || picker.querySelector('.product-variant__input');
      return r ? delen(r.value) : null;
    }
    function teken() {
      zetSchakelaar(picker, sys);
      picker.querySelectorAll('.product-variant__label [data-ux-dm-h]').forEach(function (s) {
        s.textContent = s.getAttribute(sys === 'd' ? 'data-ux-dm-d' : 'data-ux-dm-h');
      });
      var p = voorbeeld();
      if (uitleg && p) uitleg.textContent = T.uitleg.replace('{h}', p.h).replace('{d}', p.d);
      var g = gekozenRadio();
      var pg = g ? delen(g.value) : null;
      if (prop) prop.value = pg ? naamVoorEigenschap(sys, pg) : '';
    }

    window.uxMaatNaam = function (waarde) {
      var p = delen(waarde);
      if (!p) return waarde;
      var kant = sys === 'd' ? T.d : T.h;
      return (sys === 'd' ? p.d : p.h) + ' (' + (DE ? kant : kant.toLowerCase()) + ')';
    };

    if (schakelaar) {
      schakelaar.addEventListener('click', function (e) {
        var b = e.target.closest('button[data-ux-dm-sys]');
        if (!b) return;
        e.preventDefault();
        sys = b.getAttribute('data-ux-dm-sys');
        bewaar(sys);
        teken();
        document.dispatchEvent(new CustomEvent('ux-maatsysteem'));
      });
    }
    picker.addEventListener('change', function () {
      if (fout) fout.hidden = true;
      picker.classList.remove('ux-dm-let-op');
      teken();
    });

    /* Toevoegen zonder gekozen maat tegenhouden (ook via de vaste knop onderin op mobiel). */
    document.addEventListener('submit', function (e) {
      var f = e.target;
      /* getAttribute: het formulier heeft een veld name="id", waardoor f.id dat veld teruggeeft i.p.v. het formulier-id */
      if (!f || !f.getAttribute || f.getAttribute('id') !== formId) return;
      if (gekozenRadio()) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      if (fout) fout.hidden = false;
      picker.classList.remove('ux-dm-let-op');
      void picker.offsetWidth;
      picker.classList.add('ux-dm-let-op');
      var doel = schakelaar || picker;
      var top = doel.getBoundingClientRect().top + window.pageYOffset - 140;
      window.scrollTo({ top: top < 0 ? 0 : top, behavior: 'smooth' });
    }, true);

    teken();
    document.dispatchEvent(new CustomEvent('ux-maatsysteem'));
  }

  function start() {
    document.querySelectorAll('[data-ux-dm-pdp]').forEach(initPdp);
    initKaarten(document);
    /* Productkaarten die later worden ingeladen (filters, sorteren) ook meenemen. */
    if ('MutationObserver' in window) {
      new MutationObserver(function (lijst) {
        for (var i = 0; i < lijst.length; i++) {
          var nodes = lijst[i].addedNodes || [];
          for (var j = 0; j < nodes.length; j++) {
            var n = nodes[j];
            if (n.nodeType === 1 && (n.matches('[data-ux-dm-kaart]') || n.querySelector('[data-ux-dm-kaart]'))) { initKaarten(document); return; }
          }
        }
      }).observe(document.body, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
